import axios from 'axios';
import { createLogs } from './proactiveMonitoring';
import i18n from '../i18n';
import globalConfig from '../config/global/config.json';


const instance = axios.create({});

instance.interceptors.request.use(req => {
    createLogs("1", {
        data: req,
        requestName: `${req.method}_Consent_call_triggered.`,
        status: req.status, 
        statusText: req.statusText,
        locale: sessionStorage.getItem('locale')
    });
    return req;
});

instance.interceptors.response.use(
    res => {
        createLogs("1", {
            data: res.data.RetrieveConsent,
            requestName: `${res.config.method}_Consent_call_completion.`,
            status: res.status,
            statusText: res.statusText,
            locale: sessionStorage.getItem('locale')
        });
        return res;   
    },
    err => {
        createLogs("2", {
            detail: i18n.t("ERR_CSP-10002"),
            errorCode: "ERR_CSP-10002",
            status: err.request.status,
            statusText: err.request.statusText,
            locale: sessionStorage.getItem('locale')
        });
        return err;
    }
);

export const consentApiForVeeva = (countryCode, crmId, emailId, consents, requestMethod,customStr, timeStamp) => 
    instance({
        'method': requestMethod,
        'url': `${import.meta.env.VITE_SET_APIGEE_BASE_URL}/${crmId}/consent${consents ? '' : `?email=${emailId}&country=${countryCode}`}`,
        'headers': {
            "X-APIKEY": `${import.meta.env.VITE_SET_APIGEE_APIKEY}`,
            "requestid" : customStr,
            "timestamp": timeStamp
        },
        'data': consents ? 
        {
            "UpdateConsent": {
                "crmId": crmId,
                "email": emailId,
                "country": countryCode,
                "source": globalConfig.SET_SOURCE_OF_CONSENT,
                "consents": consents
            }
        } 
        : null
    }).catch(()=>false);

export const consentApiForGigya = (countryCode, payload, requestMethod, customStr, timeStamp) =>
    instance({
        'method': requestMethod,
        'url': `${import.meta.env.VITE_SET_APIGEE_GIGYA_BASE_URL}${requestMethod === 'POST' ? 'info' : ''}?buId=${countryCode}`,
        'headers': {
            "X-APIKEY": `${import.meta.env.VITE_SET_APIGEE_APIKEY}`,
            "requestid": customStr,
            "timestamp": timeStamp
        },
        'data': payload
    }).catch(() => false);